import React, { useState } from 'react';
import { X, CreditCard, IndianRupee } from 'lucide-react';

const PaymentTypeModal = ({ isOpen, onClose, onConfirm, feeInfo }) => {
  const [paymentType, setPaymentType] = useState('cash');
  const [transactionId, setTransactionId] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm({
      paymentType: paymentType,
      transactionId: paymentType === 'online' ? transactionId.trim() || null : null
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-semibold text-gray-900">Select Payment Type</h2>
              {feeInfo && (
                <p className="text-sm text-gray-600 mt-1">
                  {feeInfo.count && feeInfo.count > 1 ? (
                    <>
                      {feeInfo.count} Terms - Total: ₹{(feeInfo.amount || 0).toLocaleString()}
                    </>
                  ) : (
                    <>
                      Term {feeInfo.termNumber} - ₹{(feeInfo.amount || 0).toLocaleString()}
                    </>
                  )}
                </p>
              )}
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X size={24} />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">Payment Method *</label>
            <div className="grid grid-cols-2 gap-4">
              <button
                type="button"
                onClick={() => setPaymentType('cash')}
                className={`p-4 border-2 rounded-lg transition-all ${
                  paymentType === 'cash'
                    ? 'border-orange-500 bg-orange-50'
                    : 'border-gray-300 hover:border-gray-400'
                }`}
              >
                <div className="flex flex-col items-center space-y-2">
                  <IndianRupee size={32} className={paymentType === 'cash' ? 'text-orange-600' : 'text-gray-400'} />
                  <span className={`font-medium ${paymentType === 'cash' ? 'text-orange-900' : 'text-gray-700'}`}>
                    Cash
                  </span>
                </div>
              </button>
              
              <button
                type="button"
                onClick={() => setPaymentType('online')}
                className={`p-4 border-2 rounded-lg transition-all ${
                  paymentType === 'online'
                    ? 'border-blue-500 bg-blue-50'
                    : 'border-gray-300 hover:border-gray-400'
                }`}
              >
                <div className="flex flex-col items-center space-y-2">
                  <CreditCard size={32} className={paymentType === 'online' ? 'text-blue-600' : 'text-gray-400'} />
                  <span className={`font-medium ${paymentType === 'online' ? 'text-blue-900' : 'text-gray-700'}`}>
                    Online
                  </span>
                </div>
              </button>
            </div>
          </div>

          {paymentType === 'online' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Transaction ID
              </label>
              <input
                type="text"
                value={transactionId}
                onChange={(e) => setTransactionId(e.target.value)}
                placeholder="Enter transaction ID or reference number"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
              />
              <p className="mt-1 text-xs text-gray-500">Optional: Enter UPI reference, bank transaction ID, etc.</p>
            </div>
          )}

          <div className="flex justify-end space-x-4 pt-4 border-t border-gray-200">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center space-x-2"
            >
              <IndianRupee size={16} />
              <span>Confirm Payment</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PaymentTypeModal;

